import { render, staticRenderFns } from "./airImportBookingBasic.vue?vue&type=template&id=b42816a2&scoped=true&"
import script from "./airImportBookingBasic.vue?vue&type=script&lang=js&"
export * from "./airImportBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./airImportBookingBasic.vue?vue&type=style&index=0&id=b42816a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42816a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b42816a2')) {
      api.createRecord('b42816a2', component.options)
    } else {
      api.reload('b42816a2', component.options)
    }
    module.hot.accept("./airImportBookingBasic.vue?vue&type=template&id=b42816a2&scoped=true&", function () {
      api.rerender('b42816a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/airImportBookingBasic.vue"
export default component.exports